export function NoScript() {
	return <noscript>This page requires JavaScript to run, please enable JavaScript to continue</noscript>;
}
